import React, { useEffect, useMemo } from "react";
import { Col, Row, Card } from 'react-bootstrap';
import RenderDetailField from "containers/common/RenderDetailField";
import { createElementIdFactory } from "utils/elementIds";
import "containers/common/List.css";
import "containers/common/Table.css";
import "containers/common/Detail.css";

function HeadOfficeGeneralInfo({
    headOffice,
    handleChange,
    suburbOptions,
    handleSelectChange,
}) {
    const {
        led_head_office_id,
        tenant_name,
        telephone,
        fax,
        email,
        weburl,
        address_line_1,
        address_line_2,
        suburb,
        state,
        postcode,
        notes,
    } = headOffice;

    const createId = useMemo(() => createElementIdFactory("head-office-general-info"), []);

    useEffect(() => {
        document.title = "Head Office for " + tenant_name;
    }, [tenant_name]);

    return (
        <Card className="shadow-sm">
            <Card.Body>
                <Row>
                    <Col xl={4} lg={6} md={12} className="mb-3">
                        <Card className="h-100">
                            <Card.Header className="bg-light">Contact Details</Card.Header><Card.Body>
                                <RenderDetailField
                                    id={createId("led-head-office-id")}
                                    name="led_head_office_id"
                                    label="ID"
                                    value={led_head_office_id}
                                    onChange={handleChange}
                                    disabled={true}
                                />
                                <RenderDetailField
                                    id={createId("tenant-name")}
                                    name="tenant_name"
                                    label="Tenant Name"
                                    value={tenant_name}
                                    onChange={handleChange}
                                />
                                <RenderDetailField
                                    id={createId("telephone")}
                                    name="telephone"
                                    label="Telephone"
                                    value={telephone}
                                    onChange={handleChange}
                                />
                                <RenderDetailField
                                    id={createId("fax")}
                                    name="fax"
                                    label="Fax"
                                    value={fax}
                                    onChange={handleChange}
                                />
                                <RenderDetailField
                                    id={createId("email")}
                                    name="email"
                                    label="Email"
                                    value={email}
                                    onChange={handleChange}
                                    type="email"
                                    inputGroupText="@"
                                />
                                <RenderDetailField
                                    id={createId("weburl")}
                                    name="weburl"
                                    label="Internet"
                                    value={weburl}
                                    onChange={handleChange}
                                    inputGroupText="www."
                                />
                            </Card.Body>
                        </Card>
                    </Col>

                    <Col xl={4} lg={6} md={12} className="mb-3">
                        <Card className="h-100">
                            <Card.Header className="bg-light">Location</Card.Header>
                            <Card.Body>
                                <RenderDetailField
                                    id={createId("address-line-1")}
                                    name="address_line_1"
                                    label="Address Line 1"
                                    value={address_line_1}
                                    onChange={handleChange}
                                />
                                <RenderDetailField
                                    id={createId("address-line-2")}
                                    name="address_line_2"
                                    label="Address Line 2"
                                    value={address_line_2}
                                    onChange={handleChange}
                                />
                                <RenderDetailField
                                    id={createId("suburb")}
                                    name="suburb"
                                    label="Suburb"
                                    isSelect={true}
                                    value={headOffice.selected_suburb || (suburb ? { label: suburb, value: suburb } : null)}
                                    onChange={handleSelectChange}
                                    options={suburbOptions}
                                    onCreateOption={(inputValue) => {
                                        const newOption = { label: inputValue, value: inputValue };
                                        handleSelectChange(newOption, { name: 'suburb', action: 'create-option' });
                                    }}
                                />
                                <RenderDetailField
                                    id={createId("state")}
                                    name="state"
                                    label="State"
                                    value={state}
                                    onChange={handleChange}
                                />
                                <RenderDetailField
                                    id={createId("postcode")}
                                    name="postcode"
                                    label="Postcode"
                                    value={postcode}
                                    onChange={handleChange}
                                />
                            </Card.Body>
                        </Card>
                    </Col>

                    <Col xl={4} lg={12} md={12} className="mb-3">
                        <Card className="h-100">
                            <Card.Header className="bg-light">Additional Info</Card.Header>
                            <Card.Body>
                                <RenderDetailField
                                    id={createId("notes")}
                                    name="notes"
                                    label="Notes"
                                    value={notes}
                                    onChange={handleChange}
                                    as="textarea"
                                    bsPrefix="internal"
                                />
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </Card.Body>
        </Card>
    );
}

export default HeadOfficeGeneralInfo;